import friendsSketch from 'marketing-website/media/images/pages/pop/sketches/friends-sketch@2x.png';
import iPhoneSketches from 'marketing-website/media/images/pages/pop/sketches/iphone-sketches@2x.png';
import iPhone from 'marketing-website/media/images/pages/pop/sketches/iphone@2x.png';
import togglesSketch from 'marketing-website/media/images/pages/pop/sketches/toggles-sketch@2x.png';

const assets = {
  friendsSketch: {
    alt: 'Sketch of a list with cats',
    maxWidth: 220,
    src: friendsSketch,
  },
  iPhoneSketches: {
    alt: 'iPhone device with sketches around it',
    maxWidth: 708,
    src: iPhoneSketches,
  },
  iPhone: {
    alt: "POP's iPhone app image cropper",
    maxWidth: 273,
    src: iPhone,
    hasShadow: false,
  },
  togglesSketch: {
    alt: 'Sketch of mobile toggles/switches',
    maxWidth: 242,
    src: togglesSketch,
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/pop/sketches.js